import {
  type CommandProperties,
  createCommand,
} from '@atlassian/rovo-content-bridge-api';

/**
 * Essential wheel event data for canvas zoom/pan functionality.
 * Includes modifier keys needed to distinguish between zoom and pan gestures.
 * Also includes the iframe's viewport dimensions for accurate coordinate conversion.
 */
export type ForwardedWheelEvent = Pick<
  WheelEvent,
  'deltaX' | 'deltaY' | 'clientX' | 'clientY' | 'ctrlKey' | 'metaKey' | 'shiftKey'
> & {
  viewportWidth: number;
  viewportHeight: number;
};

/**
 * Properties for the wheel event command sent from the database iframe to the parent.
 */
export interface WheelEventCommandProperties extends CommandProperties {
  wheelEvent: ForwardedWheelEvent;
}

/**
 * Command sent from the database iframe to notify the parent application
 * of wheel events that should be handled by the parent (e.g., for canvas zoom).
 *
 * This allows the database iframe to prevent default wheel behavior and
 * forward the event data to the parent for proper canvas zoom/pan functionality.
 */
export const WheelEventCommand =
  createCommand<WheelEventCommandProperties>('wheel-event');
